export default __webpack_public_path__ + "static/media/4.18b9a44d.jpg";